// extracted by mini-css-extract-plugin
export default {"page__container":"Skeleton_page__container__e5oNn","list":"Skeleton_list__PWCp1","panel":"Skeleton_panel__Tfhuz"};